import { createSlice } from "@reduxjs/toolkit";
import { IAddTaskSlice } from "../../models/agent/Tasks/addTask";
import { PostCustomerMetrics } from "./CustomerDetailsAction";
import { Policies } from "../CustomerDetailsList/CustomerDetailsList";

interface IcustomerMetricsData {
  customerMetricsData: Policies;
}
const initialState = {
  customerMetricsData: {
    totalPolicies: { carrier: "", count: 0, statusCd: "", system: "" },
    activePolicies: { carrier: "", count: 0, statusCd: "", system: "" },
    cancelNoticePolicies: { carrier: "", count: 0, statusCd: "", system: "" },
    cancelledPolicies: { carrier: "", count: 0, statusCd: "", system: "" },
    renewalInprogressPolicies: {
      carrier: "",
      count: 0,
      statusCd: "",
      system: "",
    },
    nonRenewRequestedPolicies: {
      carrier: "",
      count: 0,
      statusCd: "",
      system: "",
    },
    nonPayCancelledPolicies: {
      carrier: "",
      count: 0,
      statusCd: "",
      system: "",
    },
    futureExpiredPolicies: { carrier: "", count: 0, statusCd: "", system: "" },
  },
};
const customerMetricsSlice = createSlice({
  name: "customerMetrics",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PostCustomerMetrics.fulfilled, (state, { payload }) => {
      state.customerMetricsData = payload.data;
    });
  },
});

export default customerMetricsSlice.reducer;
